module.exports = __webpack_public_path__ + "img/ic_visual.9a07dbe5.svg";